<template>
  <!-- 
    offer: 报价
    viewDetails: 详情
  -->
  <div class="order-detail">
    <div class="order-main container">
      <el-form label-width="120px">
        <div class="form-item-title">应急需求单信息</div>
        <el-row>
          <el-col :span="10">
            <el-form-item label="应急需求单名称:">{{ routeData.enquiryName }}</el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="报价截止时间:">{{ routeData.quotationDeadline }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="报价开始时间:">
              {{ routeData.releaseTime }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <!-- 倒计时 -->
            <div class="stop-time">
              报价剩余时间：
              <count-down v-if="routeData.quotationDeadline" :stop-time="routeData.quotationDeadline"></count-down>
              <span v-else>0天0小时0分0秒</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="询价方:">
              {{ routeData.purchaseCompany }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="期望到货日期:">
              {{ routeData.arrivalTime }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="结算方式:">
              {{ routeData.isDoC != undefined ? (routeData.isDoC === 1 ? '货到付款' : '款到发货') : '' }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="配送方式:">
              {{ formatShipmentType(routeData.shipmentType) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="联系人:">
              {{ routeData.realName }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系方式:">
              {{ routeData.mobile }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="收货地址:">{{ routeData.address }}</el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="邮箱:">{{ routeData.email }}</el-form-item>
          </el-col>
        </el-row>
        <!-- 采购商传的传的 -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:">{{ routeData.enquiryRemark }}</el-form-item>
          </el-col>
        </el-row>
        <el-row class="file-show">
          <el-col :span="16">
            <el-form-item label="附件:">
              <el-tooltip
                v-for="item of enquiryAttachmentUrlShow"
                :key="item.fileUrl"
                effect="dark"
                :content="item.fileName"
                placement="bottom"
                :disabled="checkTextOverflow(item.fileName)"
              >
                <span class="file-name" @click="downloadFile(item)">
                  {{ item.fileName }}
                </span>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-if="isShowProductInfo" class="order-main container">
      <div class="form-item-title">
        需求商品清单
        <span style="margin-left: 20px; color: #f0250f">
          <!-- {{ routeData.includeFreight == 0 ? freightText : '' }} -->
        </span>
      </div>
      <div class="form-item-btn">
        <!-- && routeQueryType !== 'offer' -->
        <eui-btn v-if="isShowConsultRecord === 1" type="primary" @click="goUrl">磋商记录</eui-btn>
        <eui-btn v-if="routeQueryType == 'offer'" type="primary" @click="openPriceDialog">批量报价</eui-btn>
      </div>
      <table-List
        style="margin-top: 10px"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="indexShow"
        :fixed-index="'left'"
        :max-height="'500'"
      >
        <template #运费="slot">
          <div>
            运费
            <el-tooltip
              v-if="routeData.includeFreight == 0"
              effect="dark"
              content="采购企业选择报价商品中包含运费，请您在商品报价时考虑运费。"
              placement="bottom"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </template>
        <!-- 报价单价 -->
        <template #unitPrice="slot">
          <el-input
            v-if="routeQueryType == 'offer' && !consultationType"
            v-model.trim="slot.scope.row.price"
            maxlength="12"
            min="0"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            class="input-style"
            style="width: 100%"
            @change="calFee(slot.scope.row, 'price')"
          ></el-input>
          <div v-else>
            <div v-if="consultationType === 1 && routeQueryType == 'offer'" style="color: #f56c6c">
              {{ slot.scope.row.supplierOfferDetailConsult.price }}
            </div>
            <div>
              <span v-if="consultationType === 1 && routeQueryType == 'offer'">(原报价:</span>
              {{
                consultationType === 1 && routeQueryType == 'offer' ? `${slot.scope.row.price})` : slot.scope.row.price
              }}
            </div>
          </div>
        </template>
        <!-- 税率 不管事1还是0都传税率 -->
        <template #taxRate="slot">
          <el-select
            v-if="routeQueryType == 'offer' && !consultationType"
            v-model="slot.scope.row.taxRate"
            clearable
            value-key="taxRateId"
            placeholder="请选择税率"
            @change="taxRateChange(slot.scope.row)"
          >
            <el-option
              v-for="taxItem in taxList"
              :key="taxItem.taxRateId"
              :label="taxItem.taxRate"
              :value="taxItem"
            ></el-option>
          </el-select>
          <span v-else>{{ slot.scope.row.taxRate.taxRate }}</span>
        </template>
        <!-- 运费 运费是如果是0  就是包邮 运费为0  如果是1 就是不包邮 写运费金额   0禁用 1需要填写 -->
        <template #unit="slot">
          <el-input
            v-if="routeQueryType == 'offer'"
            v-model.trim="slot.scope.row.deliveryFee"
            min="0"
            maxlength="12"
            :disabled="routeData.includeFreight == 0"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            class="input-style"
            style="width: 100%"
            @change="calFee(slot.scope.row, 'deliveryFee')"
          ></el-input>
          <span v-else>{{ slot.scope.row.deliveryFee }}</span>
        </template>
        <template #totalPrice="{ scope: { row } }">
          <span v-if="consultationType === 1 && routeQueryType == 'offer'">
            {{ row.supplierOfferDetailConsult.totalPrice }}
          </span>
          <span v-else>{{ row.totalPrice }}</span>
        </template>
        <!-- 操作 -->
        <template #operation="tData">
          <eui-btn
            v-if="handleDownLoadUrl(tData.scope.row)"
            v-downLoadUrl="handleDownLoadUrl(tData.scope.row)"
            type="text"
            :underline="false"
          >
            查看需求描述
          </eui-btn>
          <eui-btn type="text" :underline="false" style="margin-left: 10px" @click="handleNoteManage(tData.scope.row)">
            备注管理
          </eui-btn>
        </template>
      </table-List>
      <div v-if="allPrice" class="total-money-box">
        含税总金额：
        <span class="total-money">{{ allPrice }} CNY</span>
      </div>
    </div>

    <div class="order-main container">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <div class="form-item-title">基本信息</div>
        <el-row style="margin-bottom: 20px">
          <!-- :picker-options="pickerOptions0" -->
          <el-col :span="10">
            <el-form-item label="报价有效期至:">
              <el-date-picker
                v-if="routeQueryType == 'offer'"
                v-model="form.quotationValidity"
                :picker-options="pickerOptions0"
                type="datetime"
                placeholder="请输入报价有效期至"
              ></el-date-picker>
              <span v-else>{{ routeData.quotationValidity }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="邮箱:" prop="offerEmail">
              <el-input
                v-if="routeQueryType == 'offer'"
                v-model.trim="form.offerEmail"
                class="input-style"
                placeholder="请输入邮箱"
                auto-complete="on"
                name="enquiryOfferEmail"
              ></el-input>
              <span v-else>{{ routeData.offerEmail }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px">
          <el-col :span="10">
            <el-form-item label="联系人:" prop="offerRealName">
              <el-input
                v-if="routeQueryType == 'offer'"
                v-model="form.offerRealName"
                class="input-style"
                maxlength="30"
                placeholder="请输入联系人"
                auto-complete="on"
                name="enquiryOfferRealName"
              ></el-input>
              <span v-else>{{ routeData.offerRealName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系方式:" prop="offerMobile">
              <el-input
                v-if="routeQueryType == 'offer'"
                v-model="form.offerMobile"
                class="input-style"
                placeholder="请输入联系方式"
                auto-complete="on"
                name="enquiryOfferMobile"
              ></el-input>
              <span v-else>{{ routeData.offerMobile }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 供应商传 :url="enquiryAttachmentUrlShow" -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件:">
              <div v-if="isUploadBtn" style="width: 60%">
                <file-upload
                  :limit="3"
                  :file-size="30"
                  :upload-url="uploadUrl"
                  :verify="true"
                  :tips-message="tipsMessage"
                  :upload-image="true"
                  :accept="'.jpg,.jpeg,.png,.pdf'"
                  :if-upload-btn="isUploadBtn"
                  :url="supplierOfferAttachmentListShow"
                  @getFileInfo="getFileInfo"
                />
              </div>
              <div v-else>
                <el-tooltip
                  v-for="item of supplierOfferAttachmentListShow"
                  :key="item.fileUrl"
                  effect="dark"
                  :content="item.fileName"
                  placement="bottom"
                  :disabled="checkTextOverflow(item.fileName)"
                >
                  <span class="file-name" @click="downloadFile(item)">
                    {{ item.fileName }}
                  </span>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 弹框 -->
    <eDialog
      dialog-title="报价备注管理"
      :dialog-type="''"
      :center-dialog-visible="dialogVisible"
      :popup-width="'600px'"
      :show-close="false"
      class="dialog-main"
      :only-show-cancel="routeQueryType === 'viewDetails'"
      @updateVisible="handleUpdateVisible"
      @resetPopupData="handleResetPopupData"
      @submitPopupData="editNoteManage"
    >
      <el-form ref="formNote" :rules="rulesNote" :model="offerNoteForm" label-width="100px">
        <el-form-item label="备注信息：" prop="note">
          <el-input
            v-model="offerNoteForm.note"
            type="textarea"
            :rows="3"
            :disabled="routeQueryType == 'viewDetails'"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="routeQueryType == 'offer'" label="描述附件：" style="margin-top: 15px">
          <el-upload
            ref="upload"
            class="upload-demo"
            accept=".xls, .xlsx, .doc, .docx, .pdf, .jpg, .jpeg, .png"
            :action="uploadUrl"
            :headers="header"
            :on-remove="handleRemove"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :before-remove="beforeRemove"
            :limit="1"
            :file-list="fileList"
          >
            <eui-btn :disabled="uploadFlag" type="primary">点击上传</eui-btn>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="routeQueryType == 'viewDetails'" label="描述附件：" style="margin-top: 15px">
          <eui-btn v-downLoadUrl="supplierNote" type="text">{{ supplierNote.name }}</eui-btn>
        </el-form-item>
        <div v-if="routeQueryType == 'offer'" class="upload-prompt">
          提示：支持xls、xlsx、doc、docx、pdf、jpg、jpeg、png格式的文件，最多可上传1个，且大小小于30M。
        </div>
      </el-form>
      <!-- <span class="dialog-footer">
        <eui-btn type="primary" @click="editNoteManage">
          {{ routeQueryType == 'viewDetails' ? '取 消' : '完 成' }}
        </eui-btn>
      </span> -->
    </eDialog>
    <!-- 底部按钮 -->
    <div class="btn-bottom">
      <eui-btn type="secondary" @click="toBack(null)">
        <eui-icon icon="eicon-arrow-left"></eui-icon>
        返回
      </eui-btn>
      <eui-btn
        v-if="routeQueryType == 'offer' && !consultationType"
        v-debounce="handleSubmit"
        :disabled="btnLoading"
        type="primary"
        style="margin-left: 30px"
      >
        报价
      </eui-btn>
      <div v-if="routeQueryType == 'offer' && consultationType === 1">
        <eui-btn :disabled="btnLoading" type="primary" style="margin-left: 30px" @click="openRejectDialog">
          拒绝
        </eui-btn>
        <eui-btn v-debounce="okHandle" :disabled="btnLoading" type="primary" style="margin-left: 30px">
          确认报价
        </eui-btn>
      </div>
    </div>

    <batch-import
      :batch-import-visible.sync="batchImportVisible"
      :enquiry-id="$route.query.enquiryId"
      @getBatchImportList="getBatchImportList"
    />

    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="blackVisible"
      :popup-width="'450px'"
      :show-close="false"
      @updateVisible="handleBlackClose"
      @resetPopupData="handleBlackClose"
      @submitPopupData="handleBlackClose"
    >
      <div>
        {{ `您已被限制对该企业报价，请联系采购管家${blackInfo.purchaseButlerMobile}。` }}
      </div>
    </e-dialog>

    <e-dialog
      v-if="rejectVisible"
      dialog-title="请填写拒绝原因"
      :center-dialog-visible="rejectVisible"
      :popup-width="'500px'"
      @resetPopupData="rejectVisible = false"
      @submitPopupData="handleReject"
    >
      <el-form :model="rejectObj" label-width="100px">
        <el-form-item label="拒绝原因:">
          <el-input
            v-model="rejectObj.refuseReason"
            type="textarea"
            :row="3"
            maxlength="300"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import tableList from '@/modules/projectA/components/common/e-table-list';
import epecDialog from '@/components/common/epecDialog.vue';
import api from '@/modules/projectA/api/order';
import api2 from '@/modules/projectA/api/product/index.js';
import { epecToken } from '@/modules/projectA/utils/globalData';
import utils, { calRoundNum, getUrlKey, dealAttachmentName } from '@/modules/projectA/utils/utils';
import { callBackUrl } from '@/modules/projectA/api/config';
import { mobilePhone, isEmailAvailable } from '@/modules/projectA/utils/validate';
import apiLogin from '@/modules/projectA/api/login/index';
import moment from 'moment';
import Api from '@/modules/projectA/api/enquiry';
import BatchImport from './components/batchImport.vue';
import countDown from './countDown.vue';
import FileUpload from '../product/components/fileUpload.vue';

export default {
  name: 'EmergencySeeDetails',
  components: {
    tableList,
    countDown,
    epecDialog,
    FileUpload,
    BatchImport,
    eDialog,
  },
  data() {
    return {
      rejectVisible: false,
      rejectObj: { refuseReason: '' },

      blackVisible: false,
      blackInfo: {},
      form: {
        quotationValidity: '',
        offerEmail: '',
        offerRealName: '',
        offerMobile: '',
      },
      rules: {
        /* quotationValidity: [
          { required: true, message: '请输入报价有效期至', trigger: 'blur' }
        ], */
        offerEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: isEmailAvailable, trigger: 'blur' },
        ],
        offerRealName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        offerMobile: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { validator: mobilePhone, trigger: 'blur' },
        ],
      },
      offerNoteForm: {
        note: '',
        fileUrl: '',
        fileName: '',
      },
      rulesNote: {
        note: [{ required: true, message: '请输入备注信息', trigger: 'blur' }],
      },
      fileList: [],
      uploadFlag: false,
      enquiryId: '',
      uploadUrl: api.enquiryPrice_fileUpload,
      header: epecToken,
      indexShow: true,
      dialogVisible: false,
      aftersalesStatus: ['已提交', '已完成', '已拒绝', '已撤回'],
      aftersalesType: ['退款', '退货', '换货', '维修', '补货'],
      aftersalesReason: ['质量问题', '货物与订单不符', '下单时选择错误', '其他', '配件少送、漏件、破损'],
      routeData: {},
      params: {},
      routeQueryType: '',
      loading: false,
      tableData: [],
      imageList: [],
      tableLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          width: '180',
          fixed: 'left',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          width: '150',
        },
        {
          label: '规格型号',
          param: 'specifications',
          align: 'center',
          width: '180',
        },
        {
          label: '商品描述',
          param: 'productDescription',
          align: 'center',
          width: '150',
        },
        {
          label: '商品类目',
          param: 'categoryName',
          align: 'center',
        },
        {
          label: '需求数量',
          param: 'requiredQuantity',
          align: 'center',
        },
        {
          label: '计量单位',
          param: 'unitName',
          align: 'center',
        },
        {
          label: '*报价单价（含税）',
          param: 'price',
          align: 'center',
          slot: 'unitPrice',
          width: '150',
        },
        {
          label: '*税率',
          param: 'taxRate',
          align: 'center',
          width: '150',
          slot: 'taxRate',
        },
        {
          label: '运费',
          param: 'deliveryFee',
          align: 'center',
          width: '150',
          slot: 'unit',
          header: true,
        },
        {
          label: '小计',
          align: 'center',
          width: '80',
          slot: 'totalPrice',
        },
        {
          label: '操作',
          width: '200',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      orderTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      enquiryDetailId: '',
      taxList: [],
      pickerOptions0: {
        /* disabledDate: time => {
          const date = new Date(this.routeData.quotationDeadline).getTime();
          return time.getTime() < date;
        } */
        disabledDate: (time) => {
          const date = new Date(this.routeData.quotationDeadline).getTime();
          if (date) {
            return time.getTime() < new Date(date).getTime();
          }
        },
      },
      supplierNote: {
        name: '',
        url: '',
      },
      freightText: '采购企业选择报价商品中包含运费，请您在商品报价时考虑运费。',
      submitFlag: false,
      enquiryAttachmentUrlShow: [],
      tipsMessage: '最多上传3个附件，格式仅支持.jpg/.jpeg/.png/.pdf，每个附件大小不超过30M。',
      isUploadBtn: false,
      // 供应商展示
      supplierOfferAttachmentListShow: [],
      isShowConsultRecord: 0,

      batchImportVisible: false,

      btnLoading: false,
      isShowProductInfo: false,

      consultationType: 0,
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
    /* consultationType === 1 && routeQueryType == 'offer'" style="color: #f56c6c;">
              {{ slot.scope.row.supplierOfferDetailConsult.price  */
    allPrice() {
      let totalPrice = 0;
      this.tableData.forEach((item) => {
        console.log(item);
        if (this.consultationType === 1 && this.routeQueryType == 'offer') {
          if (item.supplierOfferDetailConsult.price) {
            totalPrice += Number(item.supplierOfferDetailConsult.totalPrice);
          }
        } else if (item.price && item.totalPrice) {
          console.log('item.totalPrice:', item.totalPrice);
          totalPrice += Number(item.totalPrice);
        }
      });
      return totalPrice.toFixed(2);
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.realName) {
          console.log(newVal, 'newVal');
          const { realName = '', mobile = '', email = '' } = newVal;
          this.form.offerEmail = email;
          this.form.offerMobile = mobile;
          this.form.offerRealName = realName;
        }
      },
    },
  },
  created() {},
  mounted() {
    const { isShowConsultRecord = 0, consultationType = 0 } = this.$route.query;
    this.consultationType = Number(consultationType);
    console.log('isShowConsultRecord:', isShowConsultRecord);
    this.isShowConsultRecord = Number(isShowConsultRecord);

    if (!this.$route.query.type) {
      // 从商城询比价跳转过来 菜单显示询价管理
      localStorage.setItem('firstIndex', '10201');
      this.enquiryId = getUrlKey('enquiryId');
      this.routeQueryType = 'offer';
    } else {
      this.routeQueryType = this.$route.query.type;
      this.enquiryId = this.$route.query.enquiryId;
    }
    // 动态修改面包屑title
    this.$store.state.tagsList.map((item) => {
      if (item.path === this.$route.fullPath) {
        const title = this.routeQueryType === 'offer' ? '应急询价报价' : '应急询价详情';
        this.$set(item, 'title', title);
      }
    });

    console.log(this.routeQueryType, 'this.routeQueryType');

    if (this.routeQueryType === 'offer') {
      if (this.consultationType === 0) {
        // 询价单详情
        this.queryEnquiryDetailByEnquiryId();
      } else {
        this.queryEnquiryDetailAndConsultByEnquiryId();
      }
      this.isUploadBtn = true;
      this.isShowProductInfo = true;
    } else {
      this.isUploadBtn = false;
      this.isShowProductInfo = true;
      this.querySupplierOfferDetailList();
    }
    this.getTaxRateList();
    // 开启延长登录
    this.getLoginActive();
    this.form.quotationValidity = moment().add('days', 90).format('YYYY-MM-DD HH:mm:ss');
  },
  beforeDestroy() {
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  },
  methods: {
    openRejectDialog() {
      this.rejectVisible = true;
    },
    async getConsultationWaitConfirm(confirmStatus, refuseReason) {
      try {
        const { purchaseCompanyId } = this.routeData;
        const { supplierOfferId, enquiryId, offerStatus = '' } = this.$route.query;
        /* // 确认状态  1：通过 2：拒绝"
          confirmStatus: 2,
          refuseReason: this.rejectObj.refuseReason, */
        const params = {
          enquiryId,
          supplierOfferId,
          purchaseCompanyId,
          confirmStatus,
        };
        // 通过
        if (confirmStatus === 1) {
          const supplierOfferDetailList = [];
          console.log(this.tableData, 'this.tableData');
          this.tableData.forEach((item) => {
            const obj = {};
            const arr = [
              {
                attachmentName: null,
                attachmentRemark: null,
                attachmentUrl: null,
              },
            ];
            obj.offerStatus = offerStatus;
            obj.deliveryFee = item.deliveryFee || 0;
            obj.enquiryDetailId = item.enquiryDetailId;
            obj.offerStatus = item.offerStatus || 0;
            obj.price = item.supplierOfferDetailConsult.price || '';
            (obj.quantity = item.requiredQuantity),
              (obj.totalPrice = item.supplierOfferDetailConsult.totalPrice),
              (obj.supplierOfferDetailAttachmentList = item.enquiryDetailNoteList || arr);
            obj.taxCode = item.taxRate?.taxRateCode || '';
            obj.taxRate = (item.taxRate && item.taxRate.taxRate.slice(0, item.taxRate.taxRate.length - 1)) || '';
            supplierOfferDetailList.push(obj);
          });
          const supplierOfferConsultAo = {
            supplierOfferDetailList,
            supplierOfferId,
            offerMobile: this.form.offerMobile,
            offerRealName: this.form.offerRealName,
            offerEmail: this.form.offerEmail,
            quotationValidity: this.form.quotationValidity ? utils.parseTime(this.form.quotationValidity) : undefined,
            enquiryId: this.enquiryId,
            haveQuotation: 0,
            includeFreight: this.routeData.includeFreight,
            includeTax: this.routeData.includeTax,
            // 新加参数
            offerRemark: this.routeData.enquiryRemark || '',
            offerAttachmentCount: this.routeData.offerAttachmentCount || 0,
            supplierOfferAttachmentAOList: this.routeData.supplierOfferAttachmentAOList || [],
            externalUrl: `${callBackUrl}/seeDetails?enquiryId=${this.enquiryId}&type=viewDetails&supplierOfferId=`,
          };
          params.supplierOfferConsultAo = supplierOfferConsultAo;
        } else {
          params.refuseReason = refuseReason;
        }

        console.log(params, '参数');
        const res = await Api.consultationWaitConfirm(params);
        if (res.code === '200') {
          this.$message.success('操作成功');
          this.rejectVisible = false;
          this.rejectObj.refuseReason = '';
          this.$router.back();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async handleReject() {
      if (!this.rejectObj.refuseReason) {
        this.$message.error('请输入拒绝原因');
        return;
      }
      this.getConsultationWaitConfirm(2, this.rejectObj.refuseReason);
    },
    okHandle() {
      this.getConsultationWaitConfirm(1);
    },
    handleBlackClose() {
      this.blackVisible = false;
    },
    dealAttachmentName,
    checkTextOverflow(str) {
      let count = 0; // 初始化字节数递加变量并获取字符串参数的字符个数
      if (str) {
        // 如果存在字符串，则执行
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2;
          } else {
            count++;
          }
        }
      }
      return count <= 20;
    },
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    // 得到备注下面附件
    getFileInfo(fileList) {
      console.log('附件：', fileList);
      /*
        fileName: (...)
        fileUrl: (...)

        "attachmentName":"询价单备注测试",
        "attachmentUrl":"www.询价单附件.com"
      */
      this.routeData.offerAttachmentCount = fileList.length;
      this.routeData.supplierOfferAttachmentAOList = fileList.map((item) => ({
        attachmentUrl: item.fileUrl,
        attachmentName: item.fileName,
      }));
    },
    // 采购商撤回申请
    async supplierOrderRefuse() {
      const params = {
        aftersalesId: this.routeData.aftersalesId,
        aftersalesStatus: this.routeData.aftersalesStatus,
        purchaseCompanyId: this.routeData.purchaseCompanyId,
      };
      const res = await api.callbackAftersales(params);
      if (res.code === '200') {
        this.$message.success('操作成功!');
        setTimeout(() => {
          let times = new Date();
          times = times.getTime();
          this.toBack(times);
        }, 1000);
      }
    },

    // 查询报价单详情
    async querySupplierOfferDetailList() {
      const result = await Api.checkEnquiryPower({
        supplierOfferId: this.$route.query.supplierOfferId,
        enquiryId: this.$route.query.enquiryId,
        checkType: 2,
      });
      if (result.code === '200') {
        if (!result.data) {
          this.$message.warning('暂无权限查看此信息。');
          this.toBack(null);
          return;
        }
      }

      const params = {
        supplierOfferId: this.$route.query.supplierOfferId,
      };
      const res = await api.querySupplierOfferDetailList(params);

      if (res.code === '200') {
        this.routeData = { ...res.data };
        // mall_userInfo
        console.log(this.mall_userInfo.companyId, res.data.supplierCompanyId, 'res.data.supplierCompanyId');
        this.isShowProductInfo = this.mall_userInfo.companyId === res.data.supplierCompanyId;
        // 展示转换
        if (res.data.enquiryAttachmentList?.length) {
          const enquiryAttachmentUrlShow = res.data.enquiryAttachmentList;
          this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
            fileUrl: item.attachmentUrl,
            fileName: item.attachmentName,
          }));
        }
        // 供应商展示文件
        if (res.data.supplierOfferAttachmentList?.length) {
          const supplierOfferAttachmentListShow = res.data.supplierOfferAttachmentList;
          this.supplierOfferAttachmentListShow = supplierOfferAttachmentListShow.map((item) => ({
            fileUrl: item.attachmentUrl,
            fileName: item.attachmentName,
          }));
        }
        this.tableData = res.data.supplierOfferDetailList;
        if (this.tableData.length) {
          const defaultTax = this.taxList.find((item) => item.taxRateId === 2 && item.taxRate === '13%');
          // 之前没判断 defaultTax 的情况 所以会报错
          if (defaultTax) {
            this.tableData.forEach((item) => this.$set(item, 'taxRate', defaultTax));
          }
        }
      }
    },
    // 供应商填写报价
    async queryEnquiryDetailAndConsultByEnquiryId() {
      try {
        const params = {
          enquiryId: this.$route.query.enquiryId,
          isSupplierVisible: 1,
          supplierOfferId: this.$route.query.supplierOfferId,
        };
        const res = await Api.queryEnquiryDetailAndConsultByEnquiryId(params);
        if (res.code === '200') {
          console.log(res, 'res飒飒飒撒所是是是');
          this.routeData = { ...res.data };
          console.log(this.routeData);
          // 展示转换
          if (res.data.enquiryAttachmentList?.length) {
            const enquiryAttachmentUrlShow = res.data.enquiryAttachmentList;
            this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
          }

          // 供应商展示文件
          if (res.data.supplierOfferAttachmentList?.length) {
            const supplierOfferAttachmentListShow = res.data.supplierOfferAttachmentList;
            this.supplierOfferAttachmentListShow = supplierOfferAttachmentListShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
          }
          this.tableData = res.data.supplierOfferDetailList;
          console.log(this.tableData, 'this.tableDatathis.tableDatathis.tableData');
          if (this.tableData.length) {
            const defaultTax = this.taxList.find((item) => item.taxRateId === 2 && item.taxRate === '13%');
            this.tableData.forEach((item) => this.$set(item, 'taxRate', defaultTax));
          }
          console.log(this.tableData, '接口this.tableData');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询询价单详情/报价新全高清
    async queryEnquiryDetailByEnquiryId() {
      console.log('查询询价单详情');
      const result = await Api.checkEnquiryPower({
        enquiryId: this.$route.query.enquiryId,
        supplierOfferId: this.$route.query.supplierOfferId,
        checkType: 3,
      });
      if (result.code === '200') {
        if (!result.data) {
          this.$message.warning('暂无权限查看此信息。');
          this.toBack(null);
          return;
        }
      }
      const params = {
        enquiryId: this.$route.query.enquiryId,
        isSupplierVisible: 1,
      };
      const res = await api.queryEnquiryDetailByEnquiryId(params);
      if (res.code === '200') {
        this.routeData = { ...res.data };
        // this.routeData.quotationDeadline =
        console.log(this.routeData);
        // 展示转换
        if (res.data.enquiryAttachmentList?.length) {
          const enquiryAttachmentUrlShow = res.data.enquiryAttachmentList;
          this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
            fileUrl: item.attachmentUrl,
            fileName: item.attachmentName,
          }));
        }

        // 供应商展示文件
        if (res.data.supplierOfferAttachmentList?.length) {
          const supplierOfferAttachmentListShow = res.data.supplierOfferAttachmentList;
          this.supplierOfferAttachmentListShow = supplierOfferAttachmentListShow.map((item) => ({
            fileUrl: item.attachmentUrl,
            fileName: item.attachmentName,
          }));
        }
        this.tableData = res.data.enquiryDetailList;
        if (this.tableData.length) {
          const defaultTax = this.taxList.find((item) => item.taxRateId === 2 && item.taxRate === '13%');
          this.tableData.forEach((item) => {
            this.$set(item, 'taxRate', defaultTax);

            console.log('item.includeFreight:', item);
            if (this.routeData.includeFreight === 1) {
              // 设置默认价格为0
              this.$set(item, 'deliveryFee', '0.00');
            }
          });
        }
        console.log(this.tableData, '接口this.tableData');
      }
    },
    // 完成确认
    async supplierOrderConfirm(flag) {
      const params = {
        aftersalesId: this.routeData.aftersalesId,
        aftersalesStatus: this.aftersalesStatus.aftersalesStatus,
        auditFlag: flag,
        purchaseCompanyId: this.routeData.purchaseCompanyId,
      };
      const res = await api.auditAftersales(params);
      if (res.code === '200') {
        this.$message.success('操作成功!');
        setTimeout(() => {
          let times = new Date();
          times = times.getTime();
          this.toBack(times);
        }, 1000);
      }
    },

    // 查看需求描述
    handleDownLoadUrl(row) {
      if (row.enquiryDetailAttachmentList?.[0].attachmentUrl) {
        let obj = {};
        obj = row.enquiryDetailAttachmentList
          ? {
              url: row.enquiryDetailAttachmentList[0].attachmentUrl,
              name: row.enquiryDetailAttachmentList[0].attachmentName,
            }
          : {};
        return obj;
      }
      return false;
    },

    // 备注管理
    handleNoteManage(val) {
      if (this.routeQueryType === 'offer') {
        if (this.offerNoteForm.fileUrl) {
          this.fileList = [
            {
              name: this.offerNoteForm.fileName,
              url: this.offerNoteForm.fileUrl,
            },
          ];
        }
        if (val.enquiryDetailNoteList && val.enquiryDetailNoteList.length) {
          this.offerNoteForm.note = val.enquiryDetailNoteList[0].attachmentRemark;
          this.offerNoteForm.fileUrl = val.enquiryDetailNoteList[0].attachmentUrl;
          this.offerNoteForm.fileName = val.enquiryDetailNoteList[0].attachmentName;
          this.fileList = [
            {
              name: val.enquiryDetailNoteList[0].attachmentName,
              url: val.enquiryDetailNoteList[0].attachmentUrl,
            },
          ];
        } else {
          this.offerNoteForm.note = '';
          this.offerNoteForm.fileUrl = '';
          this.offerNoteForm.fileName = '';
          this.fileList = [];
        }
      } else {
        this.supplierNote.name = val.supplierOfferDetailAttachmentList[0]?.attachmentName || '';
        this.supplierNote.url = val.supplierOfferDetailAttachmentList[0]?.attachmentUrl || '';
        this.offerNoteForm.note = val.supplierOfferDetailAttachmentList[0]?.attachmentRemark || '';
      }
      this.dialogVisible = true;
      this.enquiryDetailId = val.enquiryDetailId;
    },
    goUrl() {
      const { supplierOfferId = '', enquiryId = '' } = this.$route.query;
      this.$router.push({
        path: '/emergencyNegotiationRemark',
        query: {
          supplierOfferId,
          enquiryId,
        },
      });
    },

    // 关闭弹框
    handleResetPopupData() {
      if (this.routeQueryType === 'offer') {
        this.$refs.formNote.resetFields();
        this.$refs.upload.clearFiles();
      }
      this.uploadFlag = false;
      this.dialogVisible = false;
    },
    handleUpdateVisible() {
      this.dialogVisible = false;
    },
    // 删除文件
    handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.offerNoteForm.fileUrl = '';
        this.offerNoteForm.fileName = '';
        this.uploadFlag = false;
        this.fileList = [];
      }
    },
    handleBeforeUpload(file) {
      const layout = ['xls', 'xlsx', 'doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png'];
      const arr = file.name.split('.');
      const str = arr[arr.length - 1];
      if (layout.indexOf(str) === -1) {
        this.$message.warning('支持xls、xlsx、doc、docx、pdf、jpg、jpeg、png格式的文件');
        return false;
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.warning('请上传小于30M的文件！');
        return false;
      }
      return true;
    },
    beforeRemove(file) {
      return file;
    },
    handleSuccess(file) {
      if (file.code === '200') {
        this.uploadFlag = false;
        this.offerNoteForm.fileUrl = file.data.url;
        this.offerNoteForm.fileName = file.data.fileName;
        this.$message.success('上传成功！');
      } else {
        this.$message.error(file.message);
      }
    },
    // 编辑备注管理
    editNoteManage() {
      if (this.routeQueryType === 'viewDetails') {
        return (this.dialogVisible = false);
      }
      this.$refs.formNote.validate((valid) => {
        if (valid) {
          this.submitFlag = true;
          this.tableData.forEach((item) => {
            if (item.enquiryDetailId === this.enquiryDetailId) {
              item.enquiryDetailNoteList = [];
              const obj = {};
              obj.attachmentName = this.offerNoteForm.fileName || null;
              obj.attachmentRemark = this.offerNoteForm.note || null;
              obj.attachmentUrl = this.offerNoteForm.fileUrl || null;
              this.offerNoteForm.fileUrl && item.enquiryDetailNoteList.push(obj);
            }
          });
          const timer = setTimeout(() => {
            this.$refs.formNote.resetFields();
            this.$refs.upload.clearFiles();
            this.dialogVisible = false;
            this.uploadFlag = true;
            clearTimeout(timer);
          }, 500);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 税率
    async getTaxRateList() {
      const res = await api2.getTaxRateList();
      if (res.code === '200') {
        res.data.forEach((item) => {
          item.taxRate += '%';
        });
        this.taxList = res.data;
      }
    },
    // 选择税率
    taxRateChange(row) {
      console.log(row, '选择税率');
    },

    // 计算
    calFee(data, flag) {
      const isPrice = Number(data.price);
      const isDeliveryFee = Number(data.deliveryFee);
      if (isNaN(isPrice)) {
        this.$set(data, 'price', null);
        return this.$message.warning('请输入正确报价单价！');
      }
      if (this.routeData.includeFreight == 1 && isNaN(isDeliveryFee)) {
        /* this.$set(data, 'deliveryFee', 0); */
        return this.$message.warning('请输入正确运费！');
      }
      // 单价
      if (flag == 'price') {
        // 精确计算小计
        const totalPrice = calRoundNum(Number(data.price).toFixed(2), data.requiredQuantity);
        // 乘100获取精度
        const total = calRoundNum(totalPrice, 100);
        this.tableData.map((item) => item);
        this.tableData.forEach((item) => {
          console.log(item.enquiryDetailId, data.enquiryDetailId, 'data.enquiryDetailId');
          if (item.enquiryDetailId == data.enquiryDetailId) {
            item.price = Number(data.price).toFixed(2);
            if (item.deliveryFee) {
              const subNum = Number(Number(Math.round(total) / 100).toFixed(2)) + Number(item.deliveryFee);
              this.$set(item, 'totalPrice', Number(subNum).toFixed(2));
            } else {
              this.$set(item, 'totalPrice', Number(Math.round(total) / 100).toFixed(2));
              console.log(item, 'item');
            }
          }
        });
      }
      // 运费
      if (flag == 'deliveryFee') {
        this.tableData.forEach((item) => {
          if (item.enquiryDetailId == data.enquiryDetailId) {
            item.deliveryFee = Number(data.deliveryFee).toFixed(2);
            if (item.totalPrice && item.price) {
              const totalPrice = calRoundNum(Number(data.price).toFixed(2), data.requiredQuantity);
              const total = calRoundNum(totalPrice, 100);
              const subNum = Number(Number(Math.round(total) / 100).toFixed(2)) + Number(item.deliveryFee);
              this.$set(item, 'totalPrice', Number(subNum).toFixed(2));
            } else {
              this.$set(item, 'totalPrice', item.deliveryFee);
            }
          }
        });
      }
    },

    // 提交报价
    async handleSubmit() {
      let flag = false;
      const res = await Api.checkWhetherEnquirySupplier();
      if (res.code === '200') {
        if (res.data) {
          flag = res.data || false;
        }
      }

      if (!flag) {
        this.$message.warning('您不是易派客应急物资供应商，无法参与此类报价。');
        return;
      }

      // 单价校验
      if (!this.tableData.every((item) => item.price)) {
        return this.$message.warning('请填写报价单价');
      }
      // 填写报价单价
      if (this.tableData.some((item) => item.price == '0.00')) {
        return this.$message.warning('请填写报价单价');
      }

      // 填写税率
      if (!this.tableData.every((item) => item.taxRate?.taxRate)) {
        return this.$message.warning('请填写税率');
      }

      const { purchaseCompanyId } = this.routeData;
      const result = await api.blackCheck({
        inquiryCompanyId: purchaseCompanyId,
        companyId: this.$store.state.USERINFO.companyId,
      });

      if (result.code === '200') {
        if (result.data.existFlag) {
          // 弹窗提示
          this.blackVisible = true;
          this.blackInfo = { ...result.data };
        } else {
          this.$refs.form.validate((valid) => {
            if (valid) {
              const { offerStatus = '', supplierOfferId } = this.$route.query;
              const supplierOfferDetailList = [];
              this.tableData.forEach((item) => {
                const obj = {};
                const arr = [
                  {
                    attachmentName: null,
                    attachmentRemark: null,
                    attachmentUrl: null,
                  },
                ];
                obj.offerStatus = offerStatus;
                obj.deliveryFee = item.deliveryFee || 0;
                obj.enquiryDetailId = item.enquiryDetailId;
                obj.offerStatus = item.offerStatus || 0;
                obj.price = item.price || '';
                (obj.quantity = item.requiredQuantity),
                  (obj.totalPrice = item.totalPrice),
                  (obj.supplierOfferDetailAttachmentList = item.enquiryDetailNoteList || arr);
                obj.taxCode = item.taxRate?.taxRateCode || '';
                obj.taxRate = (item.taxRate && item.taxRate.taxRate.slice(0, item.taxRate.taxRate.length - 1)) || '';
                supplierOfferDetailList.push(obj);
              });

              const params = {
                supplierOfferId,
                offerMobile: this.form.offerMobile,
                offerRealName: this.form.offerRealName,
                offerEmail: this.form.offerEmail,
                quotationValidity: this.form.quotationValidity
                  ? utils.parseTime(this.form.quotationValidity)
                  : undefined,
                enquiryId: this.enquiryId,
                haveQuotation: 0,
                includeFreight: this.routeData.includeFreight,
                includeTax: this.routeData.includeTax,
                supplierOfferDetailList,
                // 新加参数
                offerRemark: this.routeData.enquiryRemark || '',
                offerAttachmentCount: this.routeData.offerAttachmentCount || 0,
                supplierOfferAttachmentAOList: this.routeData.supplierOfferAttachmentAOList || [],
                externalUrl: `${callBackUrl}/seeDetails?enquiryId=${this.enquiryId}&type=viewDetails&supplierOfferId=`,
              };
              console.log('提交参数：', params);
              if (offerStatus === '6') {
                this.supplierOfferConsult(params);
                return;
              }
              this.addSupplierOffer(params);
            } else {
              console.log('error submit!!');
            }
          });
        }
      }
    },

    async addSupplierOffer(params) {
      try {
        this.btnLoading = true;
        const res = await api.addSupplierOffer(params);
        if (res.code == '200') {
          this.$message.success('提交成功');
          this.fileList = [];
          this.offerNoteForm.note = '';
          this.offerNoteForm.fileUrl = '';
          this.offerNoteForm.fileName = '';
          this.submitFlag = false;
          setTimeout(() => {
            let times = new Date();
            times = times.getTime();
            this.toBack(times);
          }, 1000);
        }
      } finally {
        this.btnLoading = false;
      }
    },
    // 磋商报价
    async supplierOfferConsult(params) {
      try {
        this.btnLoading = true;
        const res = await api.supplierOfferConsult(params);
        if (res.code == '200') {
          this.$message.success('提交成功');
          this.fileList = [];
          this.offerNoteForm.note = '';
          this.offerNoteForm.fileUrl = '';
          this.offerNoteForm.fileName = '';
          this.submitFlag = false;
          setTimeout(() => {
            let times = new Date();
            times = times.getTime();
            this.toBack(times);
          }, 1000);
        }
      } finally {
        this.btnLoading = false;
      }
    },

    toBack(times) {
      const { back, type } = this.$route.query;
      console.log(back, 'back');
      if (type) {
        if (times !== null) {
          this.$router.push({ path: back, query: { t: times } });
        } else {
          this.$router.push({ path: back });
        }
      } else {
        let times = new Date();
        times = times.getTime();
        this.$router.push({ path: '/emergencyOpenInquiry', query: { t: times } });
      }

      // this.$router.push({ path: '/orderManage' });
    },
    openPriceDialog() {
      this.batchImportVisible = true;
    },
    getBatchImportList(data) {
      console.log(data, 'data');
      this.tableData = [...data];
      data.forEach((item) => {
        console.log(item.price, 'item.price');
        const defaultTax = this.taxList.find((iten) => {
          console.log(iten.taxRate, `${item.taxRate}%`, '对比');
          return iten.taxRate === `${item.taxRate}%`;
        });
        this.$set(item, 'taxRate', defaultTax);
        if (item.price) {
          this.calFee(item, 'price');
        }
        if (item.deliveryFee) {
          this.calFee(item, 'deliveryFee');
        }
      });
      // this.tableData = [...data];
      // console.log(data, this.tableData, "导入datadatadata");
    },
    // 心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      const token = this.$cookies.get('epecToken');
      if (token) {
        const epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        const now = new Date().getTime();
        const time = epecTokenExpiredTime;
        let timeOut = null;
        if (time > now) {
          const interval = time - now;
          console.log(interval);
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then((res) => {
            this.refreshFront();
          });
        }, timeOut);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-main {
  .el-dialog__footer {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.container {
  padding: 20px 10px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.209933);
  .file-name {
    margin-right: 10px;
    color: #0064c8;
    cursor: pointer;
    display: inline-block;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-shrink: 0;
    flex-grow: 0;
  }
}
.order-detail {
  ::v-deep .el-icon-close-tip {
    display: none;
  }
  .tip {
    display: flex;
    justify-content: flex-end;
    color: #ef4c56;
    font-size: 12px;
    margin: 20px 0 10px 0;
  }
  .back {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .button {
      width: 110px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
    }
    .operate {
      display: flex;
      .close {
        width: 126px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background: #ffe353;
        font-weight: 400;
        color: #333;
        text-align: center;
        cursor: pointer;
      }
      .refuse {
        background: #fff;
        margin-right: 20px;
      }
    }
  }
  .box-image {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding-left: 0px;
    margin-top: 10px;
    .block {
      display: block;
      margin-right: 20px;
    }
  }
  .form-item-title {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
  .form-item-btn {
    margin-top: 10px;
  }
  .el-input {
    width: 60%;
  }
}
::v-deep.el-form-item {
  margin-bottom: 0;
  word-break: break-all;
}
::v-deep.el-textarea {
  width: 90%;
}
::v-deep.el-form-item__label {
  padding: 0 5px 0 0 !important;
}
.btn-bottom {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .cancel {
    &:hover,
    :active {
      border: 1px solid #2587ff;
      color: #2587ff;
      background: #f5f5f5;
    }
  }
}
.stop-time {
  height: 24px;
  margin: 4px 0 4px 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #f0250f;
}
.total-money-box {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0 0px;
  font-weight: bold;
}
.total-money {
  color: #f0250f;
  font-weight: bold;
}
.upload-prompt {
  margin: 20px 0 10px 17px;
}
::v-deep .el-dialog__footer {
  padding: 0;
}
.dialog-footer {
  display: flex;
  margin-top: 10px;
  justify-content: center;
}
</style>
